<template>
  <div ref="dressCodeRef" class="dresscode-container">
    <h2 ref="tituloRef" class="titulo">DRESS CODE</h2>
    <p ref="subtituloRef" class="formal"> ELEGANTE MUJERES<br> VAQUERO FORMAL HOMBRES </p>

    <div class="icono-container">
      <img ref="parejaRef" src="@/assets/dresscode.svg" alt="Dress code ícono elegante" />
    </div>

    <p ref="p1Ref" class="descripcion"> <br>Reservamos el color Blanco para la novia <br>
      <strong></strong>
      <br>
    </p>
    <p ref="p2Ref" class="descripcion"></p>

    <div ref="botonesRef" class="botones-pinterest">
      <a
        href="https://pin.it/3EKPqfZVE"
        target="_blank"
        class="btn-pinterest"
        ref="btnHombres1Ref"
      >
        <i class="fas fa-mars"></i> Ideas Pinterest Hombres opción 1
      </a>

      <a
        href="https://pin.it/3nzbULzj1"
        target="_blank"
        class="btn-pinterest"
        ref="btnHombres2Ref"
      >
        <i class="fas fa-mars"></i> Ideas Pinterest Hombres opción 2
      </a>

      <a
        href="https://pin.it/34ULcHttK"
        target="_blank"
        class="btn-pinterest"
        ref="btnMujeres1Ref"
      >
        <i class="fas fa-venus"></i> Ideas Pinterest Mujeres opción 1
      </a>

      <a
        href="https://pin.it/78oEB3waP"
        target="_blank"
        class="btn-pinterest"
        ref="btnMujeres2Ref"
      >
        <i class="fas fa-venus"></i> Ideas Pinterest Mujeres opción 2
      </a>
    </div>

    <!-- BOTONES DE PINTEREST 

    <div ref="lineaRef" class="linea-decorativa"></div>

    <p ref="mensajeRef" class="descripcion mensaje-adicional">Respetuosamente, no niños por favor.</p>-->
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'DressCode',
  setup() {
    const dressCodeRef = ref(null)
    const tituloRef = ref(null)
    const subtituloRef = ref(null)
    const p1Ref = ref(null)
    const p2Ref = ref(null)
    const parejaRef = ref(null)
    const lineaRef = ref(null)
    const mensajeRef = ref(null)

    const btnHombres1Ref = ref(null)
    const btnHombres2Ref = ref(null)
    const btnMujeres1Ref = ref(null)
    const btnMujeres2Ref = ref(null)

    onMounted(() => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            gsap.fromTo(tituloRef.value, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 1 })
            gsap.fromTo(subtituloRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1, delay: 0.3 })
            gsap.fromTo(p1Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1, delay: 0.6 })
            gsap.fromTo(p2Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1, delay: 0.9 })
            gsap.fromTo(parejaRef.value, { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 1.2, delay: 1.2, ease: 'back.out(1.7)' })

            // Animaciones para TODAS las opciones de botones
            gsap.fromTo(btnHombres1Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 1.5 })
            gsap.fromTo(btnHombres2Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 1.6 })
            gsap.fromTo(btnMujeres1Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 1.7 })
            gsap.fromTo(btnMujeres2Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 1.8 })

            gsap.fromTo(lineaRef.value, { scaleX: 0 }, { scaleX: 1, duration: 1, delay: 2.1, transformOrigin: 'center' })
            gsap.fromTo(mensajeRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1, delay: 2.4 })

            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.3 })

      if (dressCodeRef.value) observer.observe(dressCodeRef.value)
    })

    return {
      dressCodeRef, tituloRef, subtituloRef, p1Ref, p2Ref,
      parejaRef, lineaRef, mensajeRef,
      btnHombres1Ref, btnHombres2Ref, btnMujeres1Ref, btnMujeres2Ref
    }
  }
}
</script>

<style scoped>
.dresscode-container {
  background-color: rgb(32, 31, 31);
  color: #f5f3e9;
  text-align: center;
  padding: 60px 20px;
  font-family: 'Playfair Display', serif;
}

.titulo {
  font-size: 28px;
  letter-spacing: 2px;
  margin-bottom: 0;
  font-weight: 500;
}

.formal {
  font-size: 15px;
  font-family: 'Poppins', sans-serif;
  font-style: italic;
  margin-top: 10px;
  margin-bottom: 12px;
  letter-spacing: 1.5px;
}

.descripcion {
  font-size: 16px;
  font-family: 'Poppins', sans-serif;
  line-height: 1.6;
  color: #f5f3e9;
  margin-bottom: 25px;
}

.mensaje-adicional {
  font-weight: 500;
  margin-top: 10px;
  font-style: italic;
}

.icono-container img {
  width: 230px;
  margin-top: 10px;
  opacity: 0;
}

/* Línea decorativa */
.linea-decorativa {
  width: 60%;
  height: 1.5px;
  background: linear-gradient(to right, transparent, #f5f3e9, transparent);
  margin: 20px auto 10px auto;
  transform: scaleX(0);
}

/* BOTONES */
.botones-pinterest {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.btn-pinterest {
  background-color: transparent;
  border: 1.5px solid #f5f3e9;
  color: #f5f3e9;
  padding: 10px 18px;
  border-radius: 30px;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-pinterest:hover {
  background-color: #f5f3e9;
  color: rgba(151, 142, 111, 255);
}

.btn-pinterest i {
  font-size: 16px;
}
</style>
